(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["Tightened-42-52"] && !Shopify.designMode) return;
  try {
    /* =====================================================================
     Drives ONE Kaching Bundles deal block that has BOTH a subscription
     toggle ("30 Day Refills" / "One-time purchase") and deal bars
     ("Buy 1" / "Buy 2, Get 1 FREE").

     CTA click sequence:
       subscribe tab      -> select "30 Day Refills" tab, select "Buy 1"
       one-time / Buy 1   -> select "One-time purchase" tab, select "Buy 1"
       one-time / Buy 2   -> select "One-time purchase" tab, select
                             "Buy 2, Get 1 FREE"
       ...then click the theme's real Add to Cart.

     IMPORTANT: Kaching is configured with ignoreDeselect:false - clicking
     an already-selected tab/bar DESELECTS it. Every selection therefore
     checks for the --selected class first and skips the click when the
     target is already selected.
     ===================================================================== */
  class CarbonRefill42Widget extends HTMLElement {
    connectedCallback() {
      this.offerInputs = this.querySelectorAll('[data-offer-input]');
      this.onetimeOptions = this.querySelectorAll('[data-onetime-option]');
      this.cta = this.querySelector('[data-add-to-cart]');
      this.ctaLabel = this.querySelector('[data-cta-label]');
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.state = 'subscribe';

      this.atcSelector = (this.dataset.atcSelector || '').trim();
      this.hideBuyArea = this.dataset.hideBuyArea !== 'false';
      this.buyAreaSelector = (this.dataset.buyAreaSelector || '').trim() || '.product-form-buttons';
      this.debug = this.dataset.debug === 'true';

      for (const r of this.offerInputs) r.addEventListener('change', () => {
        if (r.checked) this.#selectOffer(r);
      });
      this.#selectOffer(this.querySelector('[data-offer-type="subscribe"]'));
      this.cta?.addEventListener('click', () => this.#handleCta());

      this.#hideBuyAreaSoon();
      this.#hideKachingSoon();
      this.#primeCart();
    }

    /* Materialize the cart session on page load. On a brand-new session
       (no cart cookie yet), Kaching fires several cart requests at once on
       the first add; without an existing cart they race to create one and
       one can lose with a 409 (observed: main product add failed, gifts
       landed at full price). A no-op update beforehand creates the cart
       cookie so the first real add merges into an existing cart instead.
       FUNCTIONAL CHANGE (v2.2) - the only one in this version. */
    async #primeCart() {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: {} }),
        });
        this.#log('cart session primed');
      } catch (e) {
        this.#log('cart prime failed (non-fatal)', e);
      }
    }

    /* ------------------------- our UI ------------------------- */

    #selectOffer(input) {
      if (!input) return;
      // Freeze the chosen offer while the unchanged async cart handoff is running.
      if (this.cta?.disabled && this.selectedOffer) input = this.selectedOffer;
      this.selectedOffer = input;
      this.state = input.dataset.offerType;
      for (const r of this.offerInputs) {
        const active = r === input;
        r.checked = active;
        const card = r.closest('[data-offer-card]');
        card.classList.toggle('carbon42__offer--active', active);

      }
      const subscribe = this.state === 'subscribe';
      this.dataset.purchaseType = this.state;
      this.querySelector('[data-price]').textContent = subscribe ? '$42' : '$52';
      this.querySelector('[data-unit]').textContent = subscribe ? '$0.88 / gel' : '$1.08 / gel';
      this.querySelector('[data-terms]').textContent = subscribe
        ? 'Renews 24 gels every 30 days at $42 + shipping. 1st renewal charge 30 days after 1st order is shipped. 3-day reminder before every rebill. No other hidden fees or subscriptions. Cancel or pause anytime.'
        : 'One-time purchase. $52 + shipping. No recurring charges or hidden fees.';
      for (const node of this.querySelectorAll('[data-sub-only]')) node.hidden = !subscribe;
      this.#syncCta();
    }

    #syncCta() {
      if (!this.ctaLabel) return;
      this.ctaLabel.textContent = this.selectedOffer?.dataset.cta || 'ADD TO CART - $42.00';
    }

    /* ---------------------- hide the real UI ---------------------- */

    #hideBuyAreaSoon() {
      if (!this.hideBuyArea) return;
      let tries = 0;
      const run = () => {
        this.#hideThemeBuyArea();
        if (!this._buyHidden && ++tries < 25) setTimeout(run, 150);
      };
      run();
    }

    #hideThemeBuyArea() {
      if (!(this.hideBuyArea && this.buyAreaSelector)) return;
      let hid = false;
      let nodes;
      try { nodes = document.querySelectorAll(this.buyAreaSelector); } catch (e) { return; }
      for (const buy of nodes) {
        if (this.contains(buy)) continue;
        this.#hideOffscreen(buy);
        hid = true;
      }
      if (hid) { this._buyHidden = true; this.#log('theme buy area hidden'); }
    }

    #hideKachingSoon() {
      let tries = 0;
      const run = () => {
        const el = this.#findDealBlock();
        if (el) {
          this.#hideOffscreen(el.closest('kaching-bundle') || el);
          this.#log('kaching deal block found + hidden');
        }
        const subsWidget = document.querySelector('kaching-subscriptions');
        if (subsWidget && !this.contains(subsWidget)) this.#hideOffscreen(subsWidget);
        if (!el && ++tries < 40) setTimeout(run, 150);
      };
      run();
    }

    /* -------------------- find Kaching elements -------------------- */

    #findDealBlock() {
      const wanted = (this.dataset.dealBlockId || '').trim();
      const candidates = document.querySelectorAll('kaching-bundles-block, .kaching-bundles__block');
      for (const el of candidates) {
        if (this.contains(el)) continue;
        const id = el.getAttribute('deal-block-id') || el.getAttribute('data-deal-block-id');
        if (!wanted || id === wanted) return el;
      }
      return null;
    }

    #norm(s) { return (s || '').replace(/[^a-zA-Z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }

    /* Purchase-type tab (subscription toggle) inside the deal block */
    #findKachingTab(dealBlock, title) {
      if (!dealBlock) return null;
      const scope = dealBlock.querySelector('.kaching-bundles__subscriptions');
      if (!scope) return null;
      const target = this.#norm(title);
      for (const bar of scope.querySelectorAll('.kaching-bundles__bar')) {
        const t = this.#norm((bar.querySelector('.kaching-bundles__subscriptions__title') || {}).textContent);
        if (t && (t === target || t.includes(target))) return bar;
      }
      return null;
    }

    /* Deal bar (quantity offer), by id first, then by title text */
    #findKachingBar(dealBlock, barId, titleFallback) {
      if (!dealBlock) return null;
      const bars = Array.from(dealBlock.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar'));
      let bar = barId ? bars.find((b) => b.getAttribute('data-deal-bar-id') === barId) : null;
      if (!bar && titleFallback) {
        const target = this.#norm(titleFallback);
        bar = bars.find((b) => {
          const t = this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent);
          return t === target;
        });
        /* exact match first; fall back to includes */
        if (!bar) {
          bar = bars.find((b) => this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent).includes(target));
        }
      }
      return bar || null;
    }

    /* Click a tab/bar ONLY if it isn't already selected (ignoreDeselect:false
       means re-clicking a selected element would deselect it). */
    async #selectIfNeeded(el, label) {
      if (!el) throw new Error('Kaching element not found: ' + label);
      if (el.classList.contains('kaching-bundles__bar--selected')) {
        this.#log('already selected, skipping click:', label);
        return;
      }
      const target = el.matches('[role="button"]') ? el : (el.querySelector('[role="button"]') || el);
      this.#clickEl(target);
      await this.#sleep(350);
      this.#log('clicked:', label, '| now selected?', el.classList.contains('kaching-bundles__bar--selected'));
    }

    /* --------------------------- CTA flow --------------------------- */

    async #handleCta() {
      if (!this.cta) return;
      this.cta.disabled = true;
      try {
        const dealBlock = await this.#waitFor(() => {
          const el = this.#findDealBlock();
          return el?.querySelector('[data-deal-bar-id]') && el.querySelector('.kaching-bundles__subscriptions') ? el : null;
        }, { timeout: 6000 });

        if (this.state === 'subscribe') {
          const tab = this.#findKachingTab(dealBlock, this.dataset.subscribeTabTitle || '30 Day Refills');
          await this.#selectIfNeeded(tab, 'subscribe tab');
          /* re-query the bar after the tab click in case Kaching re-rendered */
          const bar = this.#findKachingBar(dealBlock, this.dataset.buy1BarId || '', this.dataset.buy1TitleFallback || 'Buy 1, Get 1 FREE');
          await this.#selectIfNeeded(bar, 'Buy 1 bar (subscribe)');
        } else {
          const tab = this.#findKachingTab(dealBlock, this.dataset.onetimeTabTitle || 'One-time purchase');
          await this.#selectIfNeeded(tab, 'one-time tab');
          const sel = this.querySelector('[data-onetime-option]:checked');
          const bar = this.#findKachingBar(dealBlock, sel?.dataset.barId || '', sel?.dataset.titleFallback || '');
          await this.#selectIfNeeded(bar, 'one-time bar');
        }

        await this.#waitFor(() => {
          const live = this.#findDealBlock();
          const inner = live?.matches('.kaching-bundles__block') ? live : live?.querySelector('.kaching-bundles__block');
          const plan = inner?.getAttribute('data-selling-plan-id') || '';
          return this.state === 'subscribe' ? plan === this.dataset.sellingPlanId : !plan;
        }, { timeout: 4000 });
        await this.#sleep(300);
        const atc = this.#findThemeAtc();
        if (!atc) throw new Error('Theme Add to Cart button not found. Set its selector in this block\u2019s settings.');
        this.#log('clicking theme Add to Cart:', atc);
        this.#clickEl(atc);
        await this.#sleep(600);
        if (this.debug) await this.#logCartState();
        this.#afterAdd();
      } catch (e) {
        console.error('[carbon42]', e);
        alert('Unable to add this offer. ' + e.message);
        this.cta.disabled = false;
      }
    }

    async #logCartState() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.#log('--- cart check after add (debug) ---');
        this.#log('all items:', cart.items.map((i) => ({
          variant_id: i.variant_id,
          title: i.title,
          price: i.price,
          has_selling_plan: !!i.selling_plan_allocation,
          kaching_bundle: i.properties && i.properties.__kaching_bundles ? JSON.parse(i.properties.__kaching_bundles) : null,
        })));
      } catch (e) {
        this.#log('cart state check failed', e);
      }
    }

    #findThemeAtc() {
      const sel = this.atcSelector ||
        'form[action*="/cart/add"] button[name="add"], .add-to-cart-button, .product-form__submit, [data-testid="standalone-add-to-cart"]';
      for (const b of document.querySelectorAll(sel)) {
        if (b.closest('carbon-refill42-widget')) continue;
        return b;
      }
      return null;
    }

    #afterAdd() {
      setTimeout(() => { if (typeof window.monster_refresh === 'function') window.monster_refresh(); }, 500);
      const mode = this.dataset.redirect;
      if (mode === 'checkout') { setTimeout(() => { window.location.href = '/checkout'; }, 700); return; }
      if (mode === 'cart') { setTimeout(() => { window.location.href = this.cartUrl; }, 700); return; }
      setTimeout(() => { if (this.cta) this.cta.disabled = false; }, 1500);
    }

    /* --------------------------- helpers --------------------------- */

    #hideOffscreen(el) {
      if (!el) return;
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', '0', 'important');
      el.style.setProperty('left', '-10000px', 'important');
      el.style.setProperty('width', '500px', 'important');
      el.style.setProperty('max-width', '90vw', 'important');
      el.setAttribute('aria-hidden', 'true');
    }

    #fire(el, type, Ctor) {
      try {
        el.dispatchEvent(new (Ctor || MouseEvent)(type, { bubbles: true, cancelable: true, composed: true, view: window, button: 0, buttons: 1 }));
      } catch (e) {
        try { el.dispatchEvent(new Event(type, { bubbles: true, cancelable: true })); } catch (e2) {}
      }
    }

    #clickEl(el) {
      if (!el) return;
      const P = window.PointerEvent || MouseEvent;
      this.#fire(el, 'pointerover', P); this.#fire(el, 'pointerenter', P);
      this.#fire(el, 'mouseover'); this.#fire(el, 'pointermove', P); this.#fire(el, 'mousemove');
      this.#fire(el, 'pointerdown', P); this.#fire(el, 'mousedown');
      try { el.focus && el.focus({ preventScroll: true }); } catch (e) {}
      this.#fire(el, 'pointerup', P); this.#fire(el, 'mouseup');
      this.#fire(el, 'click');
    }

    #waitFor(fn, { timeout = 8000, interval = 90 } = {}) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const tick = () => {
          let v = null; try { v = fn(); } catch (e) {}
          if (v) return resolve(v);
          if (Date.now() - start > timeout) return reject(new Error('waitFor timeout'));
          setTimeout(tick, interval);
        };
        tick();
      });
    }
    #sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }
    #log(...a) { if (this.debug) console.log('[carbon42]', ...a); }
  }

  if (!customElements.get('carbon-refill42-widget')) {
    customElements.define('carbon-refill42-widget', CarbonRefill42Widget);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-b1g1-42-widget"] && !Shopify.designMode) return;
  try {
    /* =====================================================================
     Drives ONE Kaching Bundles deal block that has BOTH a subscription
     toggle ("30 Day Refills" / "One-time purchase") and deal bars
     ("Buy 1" / "Buy 2, Get 1 FREE").

     CTA click sequence:
       subscribe tab      -> select "30 Day Refills" tab, select "Buy 1"
       one-time / Buy 1   -> select "One-time purchase" tab, select "Buy 1"
       one-time / Buy 2   -> select "One-time purchase" tab, select
                             "Buy 2, Get 1 FREE"
       ...then click the theme's real Add to Cart.

     IMPORTANT: Kaching is configured with ignoreDeselect:false - clicking
     an already-selected tab/bar DESELECTS it. Every selection therefore
     checks for the --selected class first and skips the click when the
     target is already selected.
     ===================================================================== */
  class CarbonRefill42Widget extends HTMLElement {
    connectedCallback() {
      this.offerInputs = this.querySelectorAll('[data-offer-input]');
      this.onetimeOptions = this.querySelectorAll('[data-onetime-option]');
      this.cta = this.querySelector('[data-add-to-cart]');
      this.ctaLabel = this.querySelector('[data-cta-label]');
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.state = 'subscribe';

      this.atcSelector = (this.dataset.atcSelector || '').trim();
      this.hideBuyArea = this.dataset.hideBuyArea !== 'false';
      this.buyAreaSelector = (this.dataset.buyAreaSelector || '').trim() || '.product-form-buttons';
      this.debug = this.dataset.debug === 'true';

      for (const r of this.offerInputs) r.addEventListener('change', () => {
        if (r.checked) this.#selectOffer(r);
      });
      this.#selectOffer(this.querySelector('[data-offer-type="subscribe"]'));
      this.cta?.addEventListener('click', () => this.#handleCta());

      this.#hideBuyAreaSoon();
      this.#hideKachingSoon();
      this.#primeCart();
    }

    /* Materialize the cart session on page load. On a brand-new session
       (no cart cookie yet), Kaching fires several cart requests at once on
       the first add; without an existing cart they race to create one and
       one can lose with a 409 (observed: main product add failed, gifts
       landed at full price). A no-op update beforehand creates the cart
       cookie so the first real add merges into an existing cart instead.
       FUNCTIONAL CHANGE (v2.2) - the only one in this version. */
    async #primeCart() {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: {} }),
        });
        this.#log('cart session primed');
      } catch (e) {
        this.#log('cart prime failed (non-fatal)', e);
      }
    }

    /* ------------------------- our UI ------------------------- */

    #selectOffer(input) {
      if (!input) return;
      // Freeze the chosen offer while the unchanged async cart handoff is running.
      if (this.cta?.disabled && this.selectedOffer) input = this.selectedOffer;
      this.selectedOffer = input;
      this.state = input.dataset.offerType;
      for (const r of this.offerInputs) {
        const active = r === input;
        r.checked = active;
        const card = r.closest('[data-offer-card]');
        card.classList.toggle('carbon42__offer--active', active);
        card.querySelector('.carbon42__details').hidden = !active;
      }
      for (const group of this.querySelectorAll('[data-purchase-group]')) {
        group.classList.toggle('carbon42__group--active', group.dataset.purchaseGroup === this.state);
      }
      this.#syncCta();
    }

    #syncCta() {
      if (!this.ctaLabel) return;
      this.ctaLabel.textContent = this.selectedOffer?.dataset.cta || 'ADD TO CART - $42.00';
    }

    /* ---------------------- hide the real UI ---------------------- */

    #hideBuyAreaSoon() {
      if (!this.hideBuyArea) return;
      let tries = 0;
      const run = () => {
        this.#hideThemeBuyArea();
        if (!this._buyHidden && ++tries < 25) setTimeout(run, 150);
      };
      run();
    }

    #hideThemeBuyArea() {
      if (!(this.hideBuyArea && this.buyAreaSelector)) return;
      let hid = false;
      let nodes;
      try { nodes = document.querySelectorAll(this.buyAreaSelector); } catch (e) { return; }
      for (const buy of nodes) {
        if (this.contains(buy)) continue;
        this.#hideOffscreen(buy);
        hid = true;
      }
      if (hid) { this._buyHidden = true; this.#log('theme buy area hidden'); }
    }

    #hideKachingSoon() {
      let tries = 0;
      const run = () => {
        const el = this.#findDealBlock();
        if (el) {
          this.#hideOffscreen(el.closest('kaching-bundle') || el);
          this.#log('kaching deal block found + hidden');
        }
        const subsWidget = document.querySelector('kaching-subscriptions');
        if (subsWidget && !this.contains(subsWidget)) this.#hideOffscreen(subsWidget);
        if (!el && ++tries < 40) setTimeout(run, 150);
      };
      run();
    }

    /* -------------------- find Kaching elements -------------------- */

    #findDealBlock() {
      const wanted = (this.dataset.dealBlockId || '').trim();
      const candidates = document.querySelectorAll('kaching-bundles-block, .kaching-bundles__block');
      for (const el of candidates) {
        if (this.contains(el)) continue;
        const id = el.getAttribute('deal-block-id') || el.getAttribute('data-deal-block-id');
        if (!wanted || id === wanted) return el;
      }
      return null;
    }

    #norm(s) { return (s || '').replace(/[^a-zA-Z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }

    /* Purchase-type tab (subscription toggle) inside the deal block */
    #findKachingTab(dealBlock, title) {
      if (!dealBlock) return null;
      const scope = dealBlock.querySelector('.kaching-bundles__subscriptions');
      if (!scope) return null;
      const target = this.#norm(title);
      for (const bar of scope.querySelectorAll('.kaching-bundles__bar')) {
        const t = this.#norm((bar.querySelector('.kaching-bundles__subscriptions__title') || {}).textContent);
        if (t && (t === target || t.includes(target))) return bar;
      }
      return null;
    }

    /* Deal bar (quantity offer), by id first, then by title text */
    #findKachingBar(dealBlock, barId, titleFallback) {
      if (!dealBlock) return null;
      const bars = Array.from(dealBlock.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar'));
      let bar = barId ? bars.find((b) => b.getAttribute('data-deal-bar-id') === barId) : null;
      if (!bar && titleFallback) {
        const target = this.#norm(titleFallback);
        bar = bars.find((b) => {
          const t = this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent);
          return t === target;
        });
        /* exact match first; fall back to includes */
        if (!bar) {
          bar = bars.find((b) => this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent).includes(target));
        }
      }
      return bar || null;
    }

    /* Click a tab/bar ONLY if it isn't already selected (ignoreDeselect:false
       means re-clicking a selected element would deselect it). */
    async #selectIfNeeded(el, label) {
      if (!el) throw new Error('Kaching element not found: ' + label);
      if (el.classList.contains('kaching-bundles__bar--selected')) {
        this.#log('already selected, skipping click:', label);
        return;
      }
      const target = el.matches('[role="button"]') ? el : (el.querySelector('[role="button"]') || el);
      this.#clickEl(target);
      await this.#sleep(350);
      this.#log('clicked:', label, '| now selected?', el.classList.contains('kaching-bundles__bar--selected'));
    }

    /* --------------------------- CTA flow --------------------------- */

    async #handleCta() {
      if (!this.cta) return;
      this.cta.disabled = true;
      try {
        const dealBlock = await this.#waitFor(() => {
          const el = this.#findDealBlock();
          return el?.querySelector('[data-deal-bar-id]') && el.querySelector('.kaching-bundles__subscriptions') ? el : null;
        }, { timeout: 6000 });

        if (this.state === 'subscribe') {
          const tab = this.#findKachingTab(dealBlock, this.dataset.subscribeTabTitle || '30 Day Refills');
          await this.#selectIfNeeded(tab, 'subscribe tab');
          /* re-query the bar after the tab click in case Kaching re-rendered */
          const bar = this.#findKachingBar(dealBlock, this.dataset.buy1BarId || '', this.dataset.buy1TitleFallback || 'Buy 1, Get 1 FREE');
          await this.#selectIfNeeded(bar, 'Buy 1 bar (subscribe)');
        } else {
          const tab = this.#findKachingTab(dealBlock, this.dataset.onetimeTabTitle || 'One-time purchase');
          await this.#selectIfNeeded(tab, 'one-time tab');
          const sel = this.querySelector('[data-onetime-option]:checked');
          const bar = this.#findKachingBar(dealBlock, sel?.dataset.barId || '', sel?.dataset.titleFallback || '');
          await this.#selectIfNeeded(bar, 'one-time bar');
        }

        await this.#waitFor(() => {
          const live = this.#findDealBlock();
          const inner = live?.matches('.kaching-bundles__block') ? live : live?.querySelector('.kaching-bundles__block');
          const plan = inner?.getAttribute('data-selling-plan-id') || '';
          return this.state === 'subscribe' ? plan === this.dataset.sellingPlanId : !plan;
        }, { timeout: 4000 });
        await this.#sleep(300);
        const atc = this.#findThemeAtc();
        if (!atc) throw new Error('Theme Add to Cart button not found. Set its selector in this block\u2019s settings.');
        this.#log('clicking theme Add to Cart:', atc);
        this.#clickEl(atc);
        await this.#sleep(600);
        if (this.debug) await this.#logCartState();
        this.#afterAdd();
      } catch (e) {
        console.error('[carbon42]', e);
        alert('Unable to add this offer. ' + e.message);
        this.cta.disabled = false;
      }
    }

    async #logCartState() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.#log('--- cart check after add (debug) ---');
        this.#log('all items:', cart.items.map((i) => ({
          variant_id: i.variant_id,
          title: i.title,
          price: i.price,
          has_selling_plan: !!i.selling_plan_allocation,
          kaching_bundle: i.properties && i.properties.__kaching_bundles ? JSON.parse(i.properties.__kaching_bundles) : null,
        })));
      } catch (e) {
        this.#log('cart state check failed', e);
      }
    }

    #findThemeAtc() {
      const sel = this.atcSelector ||
        'form[action*="/cart/add"] button[name="add"], .add-to-cart-button, .product-form__submit, [data-testid="standalone-add-to-cart"]';
      for (const b of document.querySelectorAll(sel)) {
        if (b.closest('carbon-refill42-widget')) continue;
        return b;
      }
      return null;
    }

    #afterAdd() {
      setTimeout(() => { if (typeof window.monster_refresh === 'function') window.monster_refresh(); }, 500);
      const mode = this.dataset.redirect;
      if (mode === 'checkout') { setTimeout(() => { window.location.href = '/checkout'; }, 700); return; }
      if (mode === 'cart') { setTimeout(() => { window.location.href = this.cartUrl; }, 700); return; }
      setTimeout(() => { if (this.cta) this.cta.disabled = false; }, 1500);
    }

    /* --------------------------- helpers --------------------------- */

    #hideOffscreen(el) {
      if (!el) return;
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', '0', 'important');
      el.style.setProperty('left', '-10000px', 'important');
      el.style.setProperty('width', '500px', 'important');
      el.style.setProperty('max-width', '90vw', 'important');
      el.setAttribute('aria-hidden', 'true');
    }

    #fire(el, type, Ctor) {
      try {
        el.dispatchEvent(new (Ctor || MouseEvent)(type, { bubbles: true, cancelable: true, composed: true, view: window, button: 0, buttons: 1 }));
      } catch (e) {
        try { el.dispatchEvent(new Event(type, { bubbles: true, cancelable: true })); } catch (e2) {}
      }
    }

    #clickEl(el) {
      if (!el) return;
      const P = window.PointerEvent || MouseEvent;
      this.#fire(el, 'pointerover', P); this.#fire(el, 'pointerenter', P);
      this.#fire(el, 'mouseover'); this.#fire(el, 'pointermove', P); this.#fire(el, 'mousemove');
      this.#fire(el, 'pointerdown', P); this.#fire(el, 'mousedown');
      try { el.focus && el.focus({ preventScroll: true }); } catch (e) {}
      this.#fire(el, 'pointerup', P); this.#fire(el, 'mouseup');
      this.#fire(el, 'click');
    }

    #waitFor(fn, { timeout = 8000, interval = 90 } = {}) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const tick = () => {
          let v = null; try { v = fn(); } catch (e) {}
          if (v) return resolve(v);
          if (Date.now() - start > timeout) return reject(new Error('waitFor timeout'));
          setTimeout(tick, interval);
        };
        tick();
      });
    }
    #sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }
    #log(...a) { if (this.debug) console.log('[carbon42]', ...a); }
  }

  if (!customElements.get('carbon-refill42-widget')) {
    customElements.define('carbon-refill42-widget', CarbonRefill42Widget);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-sub-only"] && !Shopify.designMode) return;
  try {
    class CarbonSubOnly extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.cta = this.querySelector('[data-add-to-cart]');
      this.ctaLabel = this.querySelector('[data-cta-label]');
      this.error = this.querySelector('[data-error]');
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.root = window.Shopify?.routes?.root || '/';
      this.scope = this.closest('.shopify-section') || document;
      this.atcSelector = (this.dataset.atcSelector || '').trim();
      this.hideBuyArea = this.dataset.hideBuyArea !== 'false';
      this.buyAreaSelector = this.dataset.buyAreaSelector || '.product-form-buttons';
      this.debug = this.dataset.debug === 'true';
      this.cta.addEventListener('click', () => this.#handleCta());
      this.#hideBuyAreaSoon();
      this.#hideKachingSoon();
      this.primePromise = this.#primeCart();
    }

    /* Materialize the cart session on page load. On a brand-new session
       (no cart cookie yet), Kaching fires several cart requests at once on
       the first add; without an existing cart they race to create one and
       one can lose with a 409 (observed: main product add failed, gifts
       landed at full price). A no-op update beforehand creates the cart
       cookie so the first real add merges into an existing cart instead.
       FUNCTIONAL CHANGE (v2.2) — the only one in this version. */
    async #primeCart() {
      try {
        await fetch(this.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: {} }),
        });
        this.#log('cart session primed');
      } catch (e) {
        this.#log('cart prime failed (non-fatal)', e);
      }
    }

    /* ---------------------- hide the real UI ---------------------- */

    #hideBuyAreaSoon() {
      if (!this.hideBuyArea) return;
      let tries = 0;
      const run = () => {
        this.#hideThemeBuyArea();
        if (!this._buyHidden && ++tries < 25) setTimeout(run, 150);
      };
      run();
    }

    #hideThemeBuyArea() {
      if (!(this.hideBuyArea && this.buyAreaSelector)) return;
      let hid = false;
      let nodes;
      try { nodes = this.scope.querySelectorAll(this.buyAreaSelector); } catch (e) { return; }
      for (const buy of nodes) {
        if (this.contains(buy) || buy.contains(this)) continue;
        this.#hideOffscreen(buy);
        hid = true;
      }
      if (hid) { this._buyHidden = true; this.#log('theme buy area hidden'); }
    }

    #hideKachingSoon() {
      let tries = 0;
      const run = () => {
        const el = this.#findDealBlock();
        if (el) {
          this.#hideOffscreen(el.closest('kaching-bundle') || el);
          this.#log('kaching deal block found + hidden');
        }
        const subsWidget = this.scope.querySelector('kaching-subscriptions');
        if (subsWidget && !this.contains(subsWidget)) this.#hideOffscreen(subsWidget);
        if (!el && ++tries < 40) setTimeout(run, 150);
      };
      run();
    }

    /* -------------------- find Kaching elements -------------------- */

    #findDealBlock() {
      const wanted = (this.dataset.dealBlockId || '').trim();
      const candidates = this.scope.querySelectorAll('kaching-bundles-block, .kaching-bundles__block');
      for (const el of candidates) {
        if (this.contains(el)) continue;
        const id = el.getAttribute('deal-block-id') || el.getAttribute('data-deal-block-id');
        if (!wanted || id === wanted) return el;
      }
      return null;
    }

    #norm(s) { return (s || '').replace(/[^a-zA-Z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }

    /* Purchase-type tab (subscription toggle) inside the deal block */
    #findKachingTab(dealBlock, title) {
      if (!dealBlock) return null;
      const scope = dealBlock.querySelector('.kaching-bundles__subscriptions');
      if (!scope) return null;
      const target = this.#norm(title);
      for (const bar of scope.querySelectorAll('.kaching-bundles__bar')) {
        const t = this.#norm((bar.querySelector('.kaching-bundles__subscriptions__title') || {}).textContent);
        if (t && (t === target || t.includes(target))) return bar;
      }
      return null;
    }

    /* Deal bar (quantity offer), by id first, then by title text */
    #findKachingBar(dealBlock, barId, titleFallback) {
      if (!dealBlock) return null;
      const bars = Array.from(dealBlock.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar'));
      let bar = barId ? bars.find((b) => b.getAttribute('data-deal-bar-id') === barId) : null;
      if (!bar && titleFallback) {
        const target = this.#norm(titleFallback);
        bar = bars.find((b) => {
          const t = this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent);
          return t === target;
        });
        /* exact match first; fall back to includes */
        if (!bar) {
          bar = bars.find((b) => this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent).includes(target));
        }
      }
      return bar || null;
    }

    /* Click a tab/bar ONLY if it isn't already selected (ignoreDeselect:false
       means re-clicking a selected element would deselect it). */
    async #selectIfNeeded(el, label) {
      if (!el) throw new Error('Kaching element not found: ' + label);
      if (el.classList.contains('kaching-bundles__bar--selected')) {
        this.#log('already selected, skipping click:', label);
        return;
      }
      const target = el.matches('[role="button"]') ? el : (el.querySelector('[role="button"]') || el);
      this.#clickEl(target);
      await this.#sleep(350);
      this.#log('clicked:', label, '| now selected?', el.classList.contains('kaching-bundles__bar--selected'));
    }

    /* --------------------------- CTA flow --------------------------- */

    async #handleCta() {
      if (!this.cta || this.cta.disabled) return;
      this.cta.disabled = true;
      this.error.hidden = true;
      try {
        await this.primePromise;
        const dealBlock = await this.#waitFor(() => this.#findDealBlock(), { timeout: 6000 });

        const tab = this.#findKachingTab(dealBlock, '30 Day Refills');
        if (tab) await this.#selectIfNeeded(tab, '30 Day Refills');
        const bar = this.#findKachingBar(this.#findDealBlock(), this.dataset.buy1BarId, 'Buy 1 Get 1 FREE');
        await this.#selectIfNeeded(bar, 'Buy 1 Get 1 FREE');
        await this.#waitFor(() => {
          const current = this.#findDealBlock();
          const selected = this.#findKachingBar(current, this.dataset.buy1BarId, 'Buy 1 Get 1 FREE');
          const planNode = current?.matches('[data-selling-plan-id]') ? current : current?.querySelector('[data-selling-plan-id]');
          return selected?.classList.contains('kaching-bundles__bar--selected') &&
            planNode?.getAttribute('data-selling-plan-id') === this.dataset.sellingPlanId;
        }, { timeout: 5000 });
        await this.#sleep(300);
        const atc = this.#findThemeAtc();
        if (!atc || atc.disabled) throw new Error('Theme Add to Cart button not found. Set its selector in this block\u2019s settings.');
        this.#log('clicking theme Add to Cart:', atc);
        this.#clickEl(atc);
        await this.#sleep(600);
        if (this.debug) await this.#logCartState();
        this.#afterAdd();
      } catch (e) {
        console.error('[custom-sub-only]', e);
        this.error.textContent = 'Unable to add this subscription. Please refresh and try again. If it continues, contact us.';
        this.error.hidden = false;
        this.cta.disabled = false;
      }
    }

    async #logCartState() {
      try {
        const res = await fetch(this.root + 'cart.js');
        const cart = await res.json();
        this.#log('--- cart check after add (debug) ---');
        this.#log('all items:', cart.items.map((i) => ({
          variant_id: i.variant_id,
          title: i.title,
          price: i.price,
          has_selling_plan: !!i.selling_plan_allocation,
          kaching_bundle: i.properties && i.properties.__kaching_bundles ? JSON.parse(i.properties.__kaching_bundles) : null,
        })));
      } catch (e) {
        this.#log('cart state check failed', e);
      }
    }

    #findThemeAtc() {
      const sel = this.atcSelector ||
        'form[action*="/cart/add"] button[name="add"], .add-to-cart-button, .product-form__submit, [data-testid="standalone-add-to-cart"]';
      for (const b of this.scope.querySelectorAll(sel)) {
        if (b.closest('carbon-sub-only')) continue;
        return b;
      }
      return null;
    }

    #afterAdd() {
      setTimeout(() => { if (typeof window.monster_refresh === 'function') window.monster_refresh(); }, 500);
      const mode = this.dataset.redirect;
      if (mode === 'checkout') { setTimeout(() => { window.location.href = this.root + 'checkout'; }, 700); return; }
      if (mode === 'cart') { setTimeout(() => { window.location.href = this.cartUrl; }, 700); return; }
      setTimeout(() => { if (this.cta) this.cta.disabled = false; }, 1500);
    }

    /* --------------------------- helpers --------------------------- */

    #hideOffscreen(el) {
      if (!el || el.contains(this)) return;
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', '0', 'important');
      el.style.setProperty('left', '-10000px', 'important');
      el.style.setProperty('width', '500px', 'important');
      el.style.setProperty('max-width', '90vw', 'important');
      el.setAttribute('aria-hidden', 'true');
    }

    #fire(el, type, Ctor) {
      try {
        el.dispatchEvent(new (Ctor || MouseEvent)(type, { bubbles: true, cancelable: true, composed: true, view: window, button: 0, buttons: 1 }));
      } catch (e) {
        try { el.dispatchEvent(new Event(type, { bubbles: true, cancelable: true })); } catch (e2) {}
      }
    }

    #clickEl(el) {
      if (!el) return;
      const P = window.PointerEvent || MouseEvent;
      this.#fire(el, 'pointerover', P); this.#fire(el, 'pointerenter', P);
      this.#fire(el, 'mouseover'); this.#fire(el, 'pointermove', P); this.#fire(el, 'mousemove');
      this.#fire(el, 'pointerdown', P); this.#fire(el, 'mousedown');
      try { el.focus && el.focus({ preventScroll: true }); } catch (e) {}
      this.#fire(el, 'pointerup', P); this.#fire(el, 'mouseup');
      this.#fire(el, 'click');
    }

    #waitFor(fn, { timeout = 8000, interval = 90 } = {}) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const tick = () => {
          let v = null; try { v = fn(); } catch (e) {}
          if (v) return resolve(v);
          if (Date.now() - start > timeout) return reject(new Error('waitFor timeout'));
          setTimeout(tick, interval);
        };
        tick();
      });
    }
    #sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }
    #log(...a) { if (this.debug) console.log('[sub-tabs]', ...a); }
  }

  if (!customElements.get('carbon-sub-only')) {
    customElements.define('carbon-sub-only', CarbonSubOnly);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-subscription-widget-60day"] && !Shopify.designMode) return;
  try {
    /* =====================================================================
     Drives Kaching BUNDLES (auto-detected by markup, so a stale selector
     setting can't break it).
     - "Buy 1, Get 1 FREE" deal bar stays selected (carries the free gifts).
       We never click it.
     - We only toggle the purchase-type options inside .kaching-bundles__subscriptions:
         60-day card   -> "Subscribe & Save"   (free gifts apply)
         one-time card -> "One-time purchase"   (single item)
       then click the theme's real Add to Cart so Kaching adds the bundle
       (incl. free gifts on the subscription) and the cart drawer opens.
     ===================================================================== */
  class KachingSubscriptionWidget extends HTMLElement {
    connectedCallback() {
      this.radios = this.querySelectorAll('.sub-widget__input');
      this.cta = this.querySelector('[data-add-to-cart]');
      this.ctaLabel = this.querySelector('.sub-widget__cta-label');
      this.cartUrl = this.dataset.cartUrl || '/cart';

      this.bundleSelector = (this.dataset.kachingSelector || '').trim();
      this.atcSelector = (this.dataset.atcSelector || '').trim();
      /* default to hiding unless explicitly turned off; tolerate blank saved selector */
      this.hideBuyArea = this.dataset.hideBuyArea !== 'false';
      this.buyAreaSelector = (this.dataset.buyAreaSelector || '').trim() || '.product-form-buttons';
      this.debug = this.dataset.debug === 'true';

      for (const r of this.radios) r.addEventListener('change', () => this.#syncCta());
      this.cta?.addEventListener('click', () => this.#handleCta());
      this.#syncCta();

      /* hide the theme buy area early, retrying a few times until it appears */
      this.#hideBuyAreaSoon();

      this.#waitFor(() => this.#findBundle(), { timeout: 12000 })
        .then((el) => {
          this.bundle = el;
          this.#hideOffscreen(this.#outerBundle(el));
          this.#hideThemeBuyArea();
          this.#log('bundle found + hidden:', this.#outerBundle(el));
        })
        .catch(() => console.warn('[sub-widget] Kaching Bundles widget not found on this page. Make sure the Kaching Bundles block is added to this template.'));
    }

    /* ---- find the Bundles widget by its markup, ignoring any stale selector ---- */
    #findBundle() {
      const sels = [this.bundleSelector, 'kaching-bundle', 'kaching-bundles-block', '.kaching-bundles', '.kaching-bundles__block'];
      for (const sel of sels) {
        if (!sel) continue;
        let nodes;
        try { nodes = document.querySelectorAll(sel); } catch (e) { continue; }
        for (const el of nodes) {
          if (el === this || this.contains(el)) continue;
          if (el.querySelector && el.querySelector('.kaching-bundles__bar')) return el;
        }
      }
      const sub = document.querySelector('.kaching-bundles__subscriptions');
      if (sub) {
        const wrap = sub.closest('kaching-bundle, kaching-bundles-block, .kaching-bundles, .kaching-bundles__block') || sub.parentElement;
        if (wrap && wrap !== this && !this.contains(wrap)) return wrap;
      }
      return null;
    }

    #outerBundle(el) {
      return el.closest('kaching-bundle') || el.closest('kaching-bundles-block') || el;
    }

    #hideBuyAreaSoon() {
      if (!this.hideBuyArea) return;
      let tries = 0;
      const run = () => {
        this.#hideThemeBuyArea();
        if (!this._buyHidden && ++tries < 25) setTimeout(run, 150);
      };
      run();
    }

    #hideThemeBuyArea() {
      if (!(this.hideBuyArea && this.buyAreaSelector)) return;
      let hid = false;
      let nodes;
      try { nodes = document.querySelectorAll(this.buyAreaSelector); } catch (e) { return; }
      for (const buy of nodes) {
        if (this.contains(buy)) continue;
        this.#hideOffscreen(buy);
        hid = true;
      }
      if (hid) { this._buyHidden = true; this.#log('theme buy area hidden'); }
    }

    #selected() { return this.querySelector('.sub-widget__input:checked'); }
    #syncCta() {
      const s = this.#selected();
      if (s && this.ctaLabel && s.dataset.cta) this.ctaLabel.textContent = s.dataset.cta;
    }

    /* find a bundle purchase-type option by label, falling back to plan type so a
       stale saved label can't break it */
    #findBundleOption(label, planType) {
      if (!this.bundle) return null;
      const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
      const scope = this.bundle.querySelector('.kaching-bundles__subscriptions') || this.bundle;
      const bars = Array.from(scope.querySelectorAll('.kaching-bundles__bar'));
      const titleOf = (bar) => norm((bar.querySelector('.kaching-bundles__subscriptions__title') || {}).textContent);
      const clickable = (bar) => (bar.matches('[role="button"]') ? bar : (bar.querySelector('[role="button"]') || bar));
      const isOneTime = (bar) => /one[\s-]?time/.test(titleOf(bar));

      /* 1) match the configured label text */
      const target = norm(label);
      if (target) {
        for (const bar of bars) { const tt = titleOf(bar); if (tt && tt.includes(target)) return clickable(bar); }
      }
      /* 2) fall back to plan type */
      if (planType === 'onetime') {
        const bar = bars.find(isOneTime);
        if (bar) return clickable(bar);
      } else {
        let bar = bars.find((b) => /subscribe/.test(titleOf(b)));
        if (!bar) bar = bars.find((b) => !isOneTime(b));
        if (bar) return clickable(bar);
      }
      return null;
    }

    async #selectBundleOption(label, planType) {
      const opt = this.#findBundleOption(label, planType);
      if (!opt) { this.#dumpOptions(label); throw new Error('Kaching bundle option not found: ' + (label || planType)); }
      this.#clickEl(opt);
      await this.#sleep(350);
      const bar = opt.closest('.kaching-bundles__bar') || opt;
      this.#log('selected bundle option ->', label, '| selected?', /--selected/.test(bar.className),
        '| form selling_plan:', this.#formSellingPlan());
    }

    #formSellingPlan() {
      const sp = document.querySelector('form[action*="/cart/add"] input[name="selling_plan"]');
      return sp ? (sp.value || '(empty)') : '(none)';
    }

    #dumpOptions(label) {
      if (!this.debug) return;
      this.#log('OPTION DEBUG looking for:', JSON.stringify(label));
      const titles = this.bundle ? this.bundle.querySelectorAll('.kaching-bundles__subscriptions__title') : [];
      titles.forEach((t, i) => this.#log(' bundle option', i, JSON.stringify((t.textContent || '').trim())));
    }

    async #handleCta() {
      const selected = this.#selected();
      if (!selected) return;
      this.cta.disabled = true;
      try {
        if (!this.bundle) this.bundle = await this.#waitFor(() => this.#findBundle(), { timeout: 5000 });
        await this.#selectBundleOption(selected.dataset.kachingLabel, selected.dataset.planType);
        await this.#sleep(300);
        const atc = this.#findThemeAtc();
        if (!atc) throw new Error('Theme Add to Cart button not found. Set its selector in this block\u2019s settings.');
        this.#log('clicking theme Add to Cart:', atc);
        this.#clickEl(atc);
        this.#afterAdd();
      } catch (e) {
        console.error('[sub-widget]', e);
        this.cta.disabled = false;
      }
    }

    #findThemeAtc() {
      const sel = this.atcSelector ||
        'form[action*="/cart/add"] button[name="add"], .add-to-cart-button, .product-form__submit, [data-testid="standalone-add-to-cart"]';
      for (const b of document.querySelectorAll(sel)) {
        if (b.closest('kaching-subscription-widget')) continue;
        return b;
      }
      return null;
    }

    #afterAdd() {
      setTimeout(() => { if (typeof window.monster_refresh === 'function') window.monster_refresh(); }, 500);
      const mode = this.dataset.redirect;
      if (mode === 'checkout') { setTimeout(() => { window.location.href = '/checkout'; }, 700); return; }
      if (mode === 'cart') { setTimeout(() => { window.location.href = this.cartUrl; }, 700); return; }
      setTimeout(() => { if (this.cta) this.cta.disabled = false; }, 1500);
    }

    /* ---- helpers ---- */
    #hideOffscreen(el) {
      if (!el) return;
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', '0', 'important');
      el.style.setProperty('left', '-10000px', 'important');
      el.style.setProperty('width', '500px', 'important');
      el.style.setProperty('max-width', '90vw', 'important');
      el.setAttribute('aria-hidden', 'true');
    }

    #fire(el, type, Ctor) {
      try {
        el.dispatchEvent(new (Ctor || MouseEvent)(type, { bubbles: true, cancelable: true, composed: true, view: window, button: 0, buttons: 1 }));
      } catch (e) {
        try { el.dispatchEvent(new Event(type, { bubbles: true, cancelable: true })); } catch (e2) {}
      }
    }

    #clickEl(el) {
      if (!el) return;
      const P = window.PointerEvent || MouseEvent;
      this.#fire(el, 'pointerover', P); this.#fire(el, 'pointerenter', P);
      this.#fire(el, 'mouseover'); this.#fire(el, 'pointermove', P); this.#fire(el, 'mousemove');
      this.#fire(el, 'pointerdown', P); this.#fire(el, 'mousedown');
      try { el.focus && el.focus({ preventScroll: true }); } catch (e) {}
      this.#fire(el, 'pointerup', P); this.#fire(el, 'mouseup');
      this.#fire(el, 'click');
    }

    #waitFor(fn, { timeout = 8000, interval = 90 } = {}) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const tick = () => {
          let v = null; try { v = fn(); } catch (e) {}
          if (v) return resolve(v);
          if (Date.now() - start > timeout) return reject(new Error('waitFor timeout'));
          setTimeout(tick, interval);
        };
        tick();
      });
    }
    #sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }
    #log(...a) { if (this.debug) console.log('[sub-widget]', ...a); }
  }

  if (!customElements.get('kaching-subscription-widget')) {
    customElements.define('kaching-subscription-widget', KachingSubscriptionWidget);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-subscription-widget-tabs"] && !Shopify.designMode) return;
  try {
    /* =====================================================================
     Drives ONE Kaching Bundles deal block that has BOTH a subscription
     toggle ("30 Day Refills" / "One-time purchase") and deal bars
     ("Buy 1" / "Buy 2, Get 1 FREE").

     CTA click sequence:
       subscribe tab      -> select "30 Day Refills" tab, select "Buy 1"
       one-time / Buy 1   -> select "One-time purchase" tab, select "Buy 1"
       one-time / Buy 2   -> select "One-time purchase" tab, select
                             "Buy 2, Get 1 FREE"
       ...then click the theme's real Add to Cart.

     IMPORTANT: Kaching is configured with ignoreDeselect:false — clicking
     an already-selected tab/bar DESELECTS it. Every selection therefore
     checks for the --selected class first and skips the click when the
     target is already selected.
     ===================================================================== */
  class SubscriptionTabsWidget extends HTMLElement {
    connectedCallback() {
      this.offerInputs = this.querySelectorAll('[data-offer-input]');
      this.onetimeOptions = this.querySelectorAll('[data-onetime-option]');
      this.cta = this.querySelector('[data-add-to-cart]');
      this.ctaLabel = this.querySelector('[data-cta-label]');
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.state = 'subscribe';

      this.atcSelector = (this.dataset.atcSelector || '').trim();
      this.hideBuyArea = this.dataset.hideBuyArea !== 'false';
      this.buyAreaSelector = (this.dataset.buyAreaSelector || '').trim() || '.product-form-buttons';
      this.debug = this.dataset.debug === 'true';

      for (const r of this.offerInputs) r.addEventListener('change', () => {
        if (r.checked) this.#selectOffer(r);
      });
      this.#selectOffer(this.querySelector('[data-offer-type="subscribe"]'));
      this.cta?.addEventListener('click', () => this.#handleCta());

      this.#hideBuyAreaSoon();
      this.#hideKachingSoon();
      this.#primeCart();
    }

    /* Materialize the cart session on page load. On a brand-new session
       (no cart cookie yet), Kaching fires several cart requests at once on
       the first add; without an existing cart they race to create one and
       one can lose with a 409 (observed: main product add failed, gifts
       landed at full price). A no-op update beforehand creates the cart
       cookie so the first real add merges into an existing cart instead.
       FUNCTIONAL CHANGE (v2.2) — the only one in this version. */
    async #primeCart() {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: {} }),
        });
        this.#log('cart session primed');
      } catch (e) {
        this.#log('cart prime failed (non-fatal)', e);
      }
    }

    /* ------------------------- our UI ------------------------- */

    #selectOffer(input) {
      if (!input) return;
      // Freeze the chosen offer while the unchanged async cart handoff is running.
      if (this.cta?.disabled && this.selectedOffer) input = this.selectedOffer;
      this.selectedOffer = input;
      this.state = input.dataset.offerType;
      for (const r of this.offerInputs) {
        const active = r === input;
        r.checked = active;
        const card = r.closest('[data-offer-card]');
        card.classList.toggle('sub-tabs__offer--active', active);
        card.querySelector('.sub-tabs__details').hidden = !active;
      }
      for (const group of this.querySelectorAll('[data-purchase-group]')) {
        group.classList.toggle('sub-tabs__group--active', group.dataset.purchaseGroup === this.state);
      }
      this.#syncCta();
    }

    #syncCta() {
      if (!this.ctaLabel) return;
      this.ctaLabel.textContent = this.selectedOffer?.dataset.cta || 'ADD TO CART - $49.00';
    }

    /* ---------------------- hide the real UI ---------------------- */

    #hideBuyAreaSoon() {
      if (!this.hideBuyArea) return;
      let tries = 0;
      const run = () => {
        this.#hideThemeBuyArea();
        if (!this._buyHidden && ++tries < 25) setTimeout(run, 150);
      };
      run();
    }

    #hideThemeBuyArea() {
      if (!(this.hideBuyArea && this.buyAreaSelector)) return;
      let hid = false;
      let nodes;
      try { nodes = document.querySelectorAll(this.buyAreaSelector); } catch (e) { return; }
      for (const buy of nodes) {
        if (this.contains(buy)) continue;
        this.#hideOffscreen(buy);
        hid = true;
      }
      if (hid) { this._buyHidden = true; this.#log('theme buy area hidden'); }
    }

    #hideKachingSoon() {
      let tries = 0;
      const run = () => {
        const el = this.#findDealBlock();
        if (el) {
          this.#hideOffscreen(el.closest('kaching-bundle') || el);
          this.#log('kaching deal block found + hidden');
        }
        const subsWidget = document.querySelector('kaching-subscriptions');
        if (subsWidget && !this.contains(subsWidget)) this.#hideOffscreen(subsWidget);
        if (!el && ++tries < 40) setTimeout(run, 150);
      };
      run();
    }

    /* -------------------- find Kaching elements -------------------- */

    #findDealBlock() {
      const wanted = (this.dataset.dealBlockId || '').trim();
      const candidates = document.querySelectorAll('kaching-bundles-block, .kaching-bundles__block');
      for (const el of candidates) {
        if (this.contains(el)) continue;
        const id = el.getAttribute('deal-block-id') || el.getAttribute('data-deal-block-id');
        if (!wanted || id === wanted) return el;
      }
      return null;
    }

    #norm(s) { return (s || '').replace(/[^a-zA-Z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }

    /* Purchase-type tab (subscription toggle) inside the deal block */
    #findKachingTab(dealBlock, title) {
      if (!dealBlock) return null;
      const scope = dealBlock.querySelector('.kaching-bundles__subscriptions');
      if (!scope) return null;
      const target = this.#norm(title);
      for (const bar of scope.querySelectorAll('.kaching-bundles__bar')) {
        const t = this.#norm((bar.querySelector('.kaching-bundles__subscriptions__title') || {}).textContent);
        if (t && (t === target || t.includes(target))) return bar;
      }
      return null;
    }

    /* Deal bar (quantity offer), by id first, then by title text */
    #findKachingBar(dealBlock, barId, titleFallback) {
      if (!dealBlock) return null;
      const bars = Array.from(dealBlock.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar'));
      let bar = barId ? bars.find((b) => b.getAttribute('data-deal-bar-id') === barId) : null;
      if (!bar && titleFallback) {
        const target = this.#norm(titleFallback);
        bar = bars.find((b) => {
          const t = this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent);
          return t === target;
        });
        /* exact match first; fall back to includes */
        if (!bar) {
          bar = bars.find((b) => this.#norm((b.querySelector('.kaching-bundles__bar-title') || {}).textContent).includes(target));
        }
      }
      return bar || null;
    }

    /* Click a tab/bar ONLY if it isn't already selected (ignoreDeselect:false
       means re-clicking a selected element would deselect it). */
    async #selectIfNeeded(el, label) {
      if (!el) throw new Error('Kaching element not found: ' + label);
      if (el.classList.contains('kaching-bundles__bar--selected')) {
        this.#log('already selected, skipping click:', label);
        return;
      }
      const target = el.matches('[role="button"]') ? el : (el.querySelector('[role="button"]') || el);
      this.#clickEl(target);
      await this.#sleep(350);
      this.#log('clicked:', label, '| now selected?', el.classList.contains('kaching-bundles__bar--selected'));
    }

    /* --------------------------- CTA flow --------------------------- */

    async #handleCta() {
      if (!this.cta) return;
      this.cta.disabled = true;
      try {
        const dealBlock = await this.#waitFor(() => this.#findDealBlock(), { timeout: 6000 });

        if (this.state === 'subscribe') {
          const tab = this.#findKachingTab(dealBlock, this.dataset.subscribeTabTitle || '30 Day Refills');
          await this.#selectIfNeeded(tab, 'subscribe tab');
          /* re-query the bar after the tab click in case Kaching re-rendered */
          const bar = this.#findKachingBar(dealBlock, this.dataset.buy1BarId || '', 'Buy 1');
          await this.#selectIfNeeded(bar, 'Buy 1 bar (subscribe)');
        } else {
          const tab = this.#findKachingTab(dealBlock, this.dataset.onetimeTabTitle || 'One-time purchase');
          await this.#selectIfNeeded(tab, 'one-time tab');
          const sel = this.querySelector('[data-onetime-option]:checked');
          const bar = this.#findKachingBar(dealBlock, sel?.dataset.barId || '', sel?.dataset.titleFallback || '');
          await this.#selectIfNeeded(bar, 'one-time bar');
        }

        await this.#sleep(300);
        const atc = this.#findThemeAtc();
        if (!atc) throw new Error('Theme Add to Cart button not found. Set its selector in this block\u2019s settings.');
        this.#log('clicking theme Add to Cart:', atc);
        this.#clickEl(atc);
        await this.#sleep(600);
        if (this.debug) await this.#logCartState();
        this.#afterAdd();
      } catch (e) {
        console.error('[sub-tabs]', e);
        this.cta.disabled = false;
      }
    }

    async #logCartState() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.#log('--- cart check after add (debug) ---');
        this.#log('all items:', cart.items.map((i) => ({
          variant_id: i.variant_id,
          title: i.title,
          price: i.price,
          has_selling_plan: !!i.selling_plan_allocation,
          kaching_bundle: i.properties && i.properties.__kaching_bundles ? JSON.parse(i.properties.__kaching_bundles) : null,
        })));
      } catch (e) {
        this.#log('cart state check failed', e);
      }
    }

    #findThemeAtc() {
      const sel = this.atcSelector ||
        'form[action*="/cart/add"] button[name="add"], .add-to-cart-button, .product-form__submit, [data-testid="standalone-add-to-cart"]';
      for (const b of document.querySelectorAll(sel)) {
        if (b.closest('subscription-tabs-widget')) continue;
        return b;
      }
      return null;
    }

    #afterAdd() {
      setTimeout(() => { if (typeof window.monster_refresh === 'function') window.monster_refresh(); }, 500);
      const mode = this.dataset.redirect;
      if (mode === 'checkout') { setTimeout(() => { window.location.href = '/checkout'; }, 700); return; }
      if (mode === 'cart') { setTimeout(() => { window.location.href = this.cartUrl; }, 700); return; }
      setTimeout(() => { if (this.cta) this.cta.disabled = false; }, 1500);
    }

    /* --------------------------- helpers --------------------------- */

    #hideOffscreen(el) {
      if (!el) return;
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', '0', 'important');
      el.style.setProperty('left', '-10000px', 'important');
      el.style.setProperty('width', '500px', 'important');
      el.style.setProperty('max-width', '90vw', 'important');
      el.setAttribute('aria-hidden', 'true');
    }

    #fire(el, type, Ctor) {
      try {
        el.dispatchEvent(new (Ctor || MouseEvent)(type, { bubbles: true, cancelable: true, composed: true, view: window, button: 0, buttons: 1 }));
      } catch (e) {
        try { el.dispatchEvent(new Event(type, { bubbles: true, cancelable: true })); } catch (e2) {}
      }
    }

    #clickEl(el) {
      if (!el) return;
      const P = window.PointerEvent || MouseEvent;
      this.#fire(el, 'pointerover', P); this.#fire(el, 'pointerenter', P);
      this.#fire(el, 'mouseover'); this.#fire(el, 'pointermove', P); this.#fire(el, 'mousemove');
      this.#fire(el, 'pointerdown', P); this.#fire(el, 'mousedown');
      try { el.focus && el.focus({ preventScroll: true }); } catch (e) {}
      this.#fire(el, 'pointerup', P); this.#fire(el, 'mouseup');
      this.#fire(el, 'click');
    }

    #waitFor(fn, { timeout = 8000, interval = 90 } = {}) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const tick = () => {
          let v = null; try { v = fn(); } catch (e) {}
          if (v) return resolve(v);
          if (Date.now() - start > timeout) return reject(new Error('waitFor timeout'));
          setTimeout(tick, interval);
        };
        tick();
      });
    }
    #sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }
    #log(...a) { if (this.debug) console.log('[sub-tabs]', ...a); }
  }

  if (!customElements.get('subscription-tabs-widget')) {
    customElements.define('subscription-tabs-widget', SubscriptionTabsWidget);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-subscription-widget"] && !Shopify.designMode) return;
  try {
    class KachingSubscriptionWidget extends HTMLElement {
    connectedCallback() {
      this.radios = this.querySelectorAll('.sub-widget__input');
      this.cta = this.querySelector('[data-add-to-cart]');
      this.ctaLabel = this.querySelector('.sub-widget__cta-label');
      this.cartUrl = this.dataset.cartUrl || '/cart';

      /* Path B config (from block settings) */
      this.kachingSelector = (this.dataset.kachingSelector || '').trim() || 'kaching-subscriptions';
      this.atcSelector = (this.dataset.atcSelector || '').trim();
      this.qtySelector = (this.dataset.qtySelector || '').trim();
      this.hideBuyArea = this.dataset.hideBuyArea === 'true';
      this.buyAreaSelector = (this.dataset.buyAreaSelector || '').trim();
      this.widgetAddsGifts = this.dataset.widgetAddsGifts === 'true';
      this.debug = this.dataset.debug === 'true';

      for (const radio of this.radios) {
        radio.addEventListener('change', () => this.#syncCta());
      }

      this.cta?.addEventListener('click', () => this.#handleCta());
      this.#syncCta();

      /* Find Kaching's native widget (it loads async), then hide it off-screen. */
      this.#waitFor(() => this.#findKaching(), { timeout: 10000 })
        .then((el) => {
          this.kaching = el;
          this.#hideOffscreen(el);
          this.#log('native Kaching widget found and hidden:', el);

          if (this.hideBuyArea && this.buyAreaSelector) {
            const buy = document.querySelector(this.buyAreaSelector);
            if (buy) {
              this.#hideOffscreen(buy);
              this.#log('theme buy area hidden:', buy);
            } else {
              this.#log('theme buy area selector matched nothing:', this.buyAreaSelector);
            }
          }
        })
        .catch(() => {
          console.warn('[sub-widget] Kaching native widget not found with selector "' +
            this.kachingSelector + '". Add Kaching\u2019s app block to this product page.');
        });
    }

    /* Locate the native Kaching widget, ignoring this element. Returns the first
       match that actually contains the subscription card markup. */
    #findKaching() {
      const matches = document.querySelectorAll(this.kachingSelector);
      for (const el of matches) {
        if (el === this || this.contains(el)) continue;
        if (el.querySelector('.ks-card-wrapper, .kaching-subscriptions__card-wrapper')) {
          return el;
        }
      }
      return null;
    }

    #log(...args) {
      if (this.debug) console.log('[sub-widget]', ...args);
    }

    #selected() {
      return this.querySelector('.sub-widget__input:checked');
    }

    #syncCta() {
      const selected = this.#selected();
      if (selected && this.ctaLabel && selected.dataset.cta) {
        this.ctaLabel.textContent = selected.dataset.cta;
      }
    }

    /* ---------- small helpers ---------- */

    /* Resolve when fn() returns truthy; reject after timeout. */
    #waitFor(fn, { timeout = 6000, interval = 80 } = {}) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const tick = () => {
          let v = null;
          try { v = fn(); } catch (e) { v = null; }
          if (v) return resolve(v);
          if (Date.now() - start > timeout) return reject(new Error('waitFor timeout'));
          setTimeout(tick, interval);
        };
        tick();
      });
    }

    #sleep(ms) {
      return new Promise((r) => setTimeout(r, ms));
    }

    /* Hide an element but keep it rendered + interactive for programmatic clicks. */
    /* Hide Kaching's widget the SAME way that worked in manual testing: full size
       and fully interactive (no opacity/pointer-events tricks that can stop its
       dropdown from opening) — just pushed off-screen so shoppers don't see it.
       The dropdown menu renders inline inside the widget, so it stays off-screen
       too (no visible flash) while remaining in the DOM for us to drive. */
    #hideOffscreen(el) {
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', '0', 'important');
      el.style.setProperty('left', '-10000px', 'important');
      el.style.setProperty('width', '500px', 'important');
      el.style.setProperty('max-width', '90vw', 'important');
      el.setAttribute('aria-hidden', 'true');
    }

    #fire(el, type, Ctor) {
      try {
        el.dispatchEvent(new (Ctor || MouseEvent)(type, {
          bubbles: true, cancelable: true, composed: true, view: window, button: 0, buttons: 1
        }));
      } catch (e) {
        try { el.dispatchEvent(new Event(type, { bubbles: true, cancelable: true })); } catch (e2) {}
      }
    }

    /* Simulate a genuine mouse interaction. Kaching's widget reacts to pointer
       events, not just a bare .click(), so we fire the whole sequence. Exactly one
       'click' is dispatched (no extra el.click()) to avoid double-toggling. */
    #clickEl(el) {
      if (!el) return;
      const P = window.PointerEvent || MouseEvent;
      this.#fire(el, 'pointerover', P);
      this.#fire(el, 'pointerenter', P);
      this.#fire(el, 'mouseover');
      this.#fire(el, 'pointermove', P);
      this.#fire(el, 'mousemove');
      this.#fire(el, 'pointerdown', P);
      this.#fire(el, 'mousedown');
      try { el.focus && el.focus({ preventScroll: true }); } catch (e) {}
      this.#fire(el, 'pointerup', P);
      this.#fire(el, 'mouseup');
      this.#fire(el, 'click');
    }

    /* ---------- driving Kaching's native widget ---------- */

    async #selectOneTime() {
      const card = this.kaching.querySelector('.kaching-subscriptions__card-wrapper.one-time-purchase');
      if (!card) throw new Error('Kaching one-time card not found');
      this.#clickEl(card);
      const radio = card.querySelector('.kaching-subscriptions__card-radio');
      if (radio) this.#clickEl(radio);
      await this.#sleep(250);
      this.#log('Kaching: clicked one-time | selected?', /selected/.test(card.className));
    }

    /* Flat template: each plan is its own clickable row (no dropdown).
       Click the row whose text matches the plan label (e.g. "90-Day Supply"). */
    async #selectSubscription(label) {
      const row = this.#findPlanRow(label);
      if (!row) {
        this.#dumpPlans(label);
        throw new Error('Kaching plan row not found for: ' + label);
      }
      this.#clickEl(row);
      const radio = row.querySelector('.kaching-subscriptions__card-radio');
      if (radio) this.#clickEl(radio);
      await this.#sleep(300);

      const selected = /selected/.test(row.className) ||
        (radio && /selected/.test(radio.className)) ||
        (row.closest('[class*="card-wrapper"]') && /selected/.test(row.closest('[class*="card-wrapper"]').className));
      this.#log('Kaching: clicked plan row ->', label, '| selected?', !!selected);
      if (!selected) this.#log('NOTE: row did not show a selected state after the click.');
    }

    /* Find the clickable plan row whose text contains `label`. */
    #findPlanRow(label) {
      const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();
      const target = norm(label);

      /* Each plan's text lives in a .kaching-subscriptions__selling-plan-info element. */
      const infos = this.kaching.querySelectorAll('.kaching-subscriptions__selling-plan-info');
      let info = null;
      for (const el of infos) {
        if (norm(el.textContent).includes(target)) { info = el; break; }
      }
      if (!info) {
        /* fallback: any element whose text contains the label, inside a subscription card */
        const cand = this.kaching.querySelectorAll('[class*="selling-plan"], [class*="card"]');
        for (const el of cand) {
          if (norm(el.textContent).includes(target) && el.querySelector('.kaching-subscriptions__card-radio')) {
            info = el; break;
          }
        }
      }
      if (!info) return null;

      /* climb to the row container that also holds the radio (the full clickable row) */
      let row = info;
      let p = info.parentElement;
      for (let i = 0; i < 4 && p && p !== this.kaching; i++) {
        if (p.querySelector('.kaching-subscriptions__card-radio')) { row = p; break; }
        p = p.parentElement;
      }
      return row;
    }

    /* Diagnostic (debug only): what plan rows exist and what they contain. */
    #dumpPlans(label) {
      this.#log('PLAN DEBUG ----------------------------------------');
      this.#log('PLAN DEBUG looking for:', JSON.stringify(label));
      const infos = this.kaching.querySelectorAll('.kaching-subscriptions__selling-plan-info');
      this.#log('PLAN DEBUG selling-plan-info rows found:', infos.length);
      infos.forEach((el, i) =>
        this.#log('PLAN DEBUG  row', i, '| text:', JSON.stringify((el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 50))));
      this.#log('PLAN DEBUG kaching size:',
        this.kaching.getBoundingClientRect().width + 'x' + this.kaching.getBoundingClientRect().height);
    }

    /* ---------- theme product form ---------- */

    #setQuantity(qty) {
      const sel = this.qtySelector ||
        '.quantity__input, input[name="quantity"], input.quantity-selector__input, quantity-input input';
      const inputs = document.querySelectorAll(sel);
      let set = false;
      for (const input of inputs) {
        if (input.closest('kaching-subscription-widget')) continue;
        input.value = String(qty);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        set = true;
      }
      this.#log(set ? ('quantity set -> ' + qty) : 'quantity input not found (using store default)');
    }

    #findThemeAtc() {
      const sel = this.atcSelector ||
        'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], ' +
        '.product-form__submit, button[name="add"], [data-add-to-cart-button]';
      const buttons = document.querySelectorAll(sel);
      for (const b of buttons) {
        if (b.closest('kaching-subscription-widget')) continue; /* skip our own CTA */
        return b;
      }
      return null;
    }

    /* ---------- main flow ---------- */

    async #handleCta() {
      const selected = this.#selected();
      if (!selected) return;

      this.cta.disabled = true;
      try {
        if (!this.kaching) {
          this.kaching = await this.#waitFor(() => this.#findKaching(), { timeout: 5000 });
        }

        /* Stays hidden — flat rows are driven in place (no dropdown to open). */
        const type = selected.dataset.planType;
        if (type === 'onetime') {
          await this.#selectOneTime();
        } else {
          await this.#selectSubscription(selected.dataset.kachingLabel);
        }

        /* let Kaching inject its hidden selling_plan input into the product form */
        await this.#sleep(350);

        this.#setQuantity(Number(selected.dataset.quantity || '1'));
        await this.#sleep(120);

        const atc = this.#findThemeAtc();
        if (!atc) {
          throw new Error('Theme Add to Cart button not found. Set "Theme Add-to-Cart selector" in this block\u2019s settings.');
        }
        this.#log('clicking theme Add to Cart:', atc);
        this.#clickEl(atc);

        /* Optional: widget adds gifts itself (off by default; prefer Kaching\u2019s gift policy). */
        if (this.widgetAddsGifts) {
          await this.#sleep(900);
          await this.#maybeAddGifts(selected);
        }

        this.#afterAdd();
      } catch (error) {
        console.error('[sub-widget]', error);
        this.cta.disabled = false;
      }
    }

    async #maybeAddGifts(selected) {
      const giftIds = (selected.dataset.giftIds || '')
        .split(',').map((s) => s.trim()).filter(Boolean);
      if (!giftIds.length) return;

      const addUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
      const items = giftIds.map((gid) => ({ id: Number(gid), quantity: 1 }));
      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          console.warn('[sub-widget] gift not added:', err.description || res.status);
        } else if (typeof window.monster_refresh === 'function') {
          window.monster_refresh();
        }
      } catch (e) {
        console.warn('[sub-widget] gift add error:', e);
      }
    }

    /* Kaching + the theme already handle the cart drawer when the real ATC fires.
       This only handles optional redirects and re-enabling the button. */
    #afterAdd() {
      const mode = this.dataset.redirect;

      if (mode === 'checkout') {
        setTimeout(() => { window.location.href = '/checkout'; }, 600);
        return;
      }
      if (mode === 'cart') {
        setTimeout(() => { window.location.href = this.cartUrl; }, 600);
        return;
      }

      setTimeout(() => { this.cta.disabled = false; }, 1500);
    }
  }

  if (!customElements.get('kaching-subscription-widget')) {
    customElements.define('kaching-subscription-widget', KachingSubscriptionWidget);
  }
  } catch(e) { console.error(e); }
})();

})();
